/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CombustivelListComponent}  from "./combustivel-list/combustivel-list.component";
import { editRoute, newRoute } from "../../shared/services/data.service";
import { CombustivelFormComponent } from "./combustivel-form/combustivel-form.component";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class CombustiveisRoutingModule {}


export const combustiveisRoutes: any[] = [
  {
    path: '',
    component: CombustivelListComponent
  },{
    path: editRoute + '/:id',
    component: CombustivelFormComponent
  },{
    path: newRoute,
    component: CombustivelFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/combustiveis-routing.module.ts
 **/